/**
 * Get the URL for an uploaded image, using the UPLOADS_BASE_URL injected from
 * the server.
 */
export function getUploadURL({ key }: { key: string }) {
  return `${window.UPLOADS_BASE_URL}/${key}`;
}
